import React, {Component} from 'react';

export default class PlainStretchersOrderingTable extends Component {
  constructor (props) {
    super (props);
  }

  render () {
    const {orderingItems} = this.props;
    return (
      <div className="main-product__table ordering-table ordering-table--with-description">
        <table>
          <thead>
            <tr>
              <th>Part number</th>
              <th>Part description</th>
              <th>Diameter [mm]</th>
              <th>Length [m]</th>
              <th>TDBF [kN]</th>
            </tr>
          </thead>
          <tbody>
            {orderingItems.map (item => (
              <tr key={item.Id}>
                <td>{item.Number}</td>
                <td>{item.Description}</td>
                <td>{item.Diameter}</td>
                <td>{item.Length}</td>
                <td>{item.MBLSplicedInkN}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}
